var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.517 0H2.4v6.223h6.117z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.308 24v-9.486h7.414V24h5.902V0h-5.902v9.386H2.4V24Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHIcon);
export default __webpack_public_path__ + "static/media/HIcon.44aea4db27605805464cc688cc1bb7ca.svg";
export { ForwardRef as ReactComponent };